/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Card,
  CardContent,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
  Button,
  Combobox,
  DatePicker,
  Input,
  cn,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { showToast } from "utils/helper";
import { UserContext } from "utils/reducers/user";
import { format, formatDate } from "date-fns";
import type { GridCellProps } from "@progress/kendo-react-grid";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import type { NumericTextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import {
  useGetCashCenters,
  useGetDedicatedShiftRoutes,
} from "utils/apis/lookups.api";
import {
  useConfirmReceiveReceipt,
  useDownloadInterbranchReceivingReport,
  useGetInterBranchIncomingOrders,
  useRecordReceivedDiscrepancy,
} from "utils/apis/inter-branch.api";
import RouteEndReportGenerator from "./routeEndReport";
import { FileDownIcon } from "lucide-react";
import Dispatch from "./dispatch";
import Swal from "sweetalert2";
import { MAX_IDLE_TIME, MAX_TOTAL_TIME, MIN_LENGTH } from "utils/constant";

export default function InterBranchManagement() {
  const currentDate = new Date();
  const user = useContext(UserContext);
  const excelExporter = useRef<any>(null);
  const buffer = useRef("");
  const startTime = useRef<number | null>(null);
  const lastTime = useRef<number | null>(null);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const [operationType, setOperationType] = useState("dispatch");
  const [ddlRoutes, setDdlRoutes] = useState("");
  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [sealNo, setSealNo] = useState("");
  const [sealNoError, setSealNoError] = useState(false);
  const [packagesConsignments, setPackagesConsignments] = useState<any>([]);
  const [consignments, setConsignments] = useState<any>([]);
  const [coinsConsignments, setCoinsConsignments] = useState<any>([]);
  const [operationDate, setOperationDate] = useState(currentDate);

  const { data: routes } = useGetDedicatedShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: cashCenters } = useGetCashCenters();

  const {
    isSuccess: incomingOrdersSuccess,
    isError: incomingOrdersError,
    data: incomingOrders,
    refetch: resetInComings,
    isFetching: loadingRequests,
  } = useGetInterBranchIncomingOrders({
    cashCenterId: user.CashCenterId,
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    shift: "morning",
    routeNo: ddlRoutes,
    fieldTeamCashCenterId: ddlCashCenters,
    isFetchOnMount: operationType === "receiving",
  });

  const {
    mutate: recordReceivedDiscrepancy,
    isSuccess: recordDiscrepancySuccess,
    isPending: recordDiscrepancyPending,
    reset: resetDiscrepancy,
  } = useRecordReceivedDiscrepancy();

  const {
    mutate: receiveOrders,
    isSuccess: receiveOrdersSuccess,
    isPending: receiveOrdersPending,
    reset: resetReceipt,
  } = useConfirmReceiveReceipt();

  const {
    mutate: downloadRecordDiscrepancy,
    isSuccess: downloadSuccess,
    isPending: downloadPending,
    data: reportData,
    reset: resetDownload,
  } = useDownloadInterbranchReceivingReport();

  const handleDownloadRecordDiscrepancy = () => {
    if (!ddlRoutes) return showToast("error", "Select Route first.");
    downloadRecordDiscrepancy({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
      shift: "morning",
      fieldTeamCashCenterId: ddlCashCenters,
    });
  };

  const onOperationDateChanged = (date?: Date) => {
    if (date) setOperationDate(date);
    setDdlRoutes("");
  };

  const reset = () => {
    buffer.current = "";
    startTime.current = null;
    lastTime.current = null;
    if (timer.current) clearTimeout(timer.current);
  };

  const reject = () => {
    showToast("error", "Manual entry is not allowed. Please use scanner.");
    setSealNo("");
    reset();
  };

  const accept = () => {
    if (buffer.current.length < MIN_LENGTH) {
      reject();
      return;
    }

    // setError("");
    setSealNo(buffer.current);
    verifyBag(buffer.current);
    // eslint-disable-next-line no-console
    console.log("✅ Scanned:");

    reset();
    // ✅ Keep focus on same input
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const processEnd = () => {
    const totalTime =
      startTime.current && lastTime.current
        ? lastTime.current - startTime.current
        : 9999;

    if (totalTime > MAX_TOTAL_TIME) {
      reject();
    } else {
      accept();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!packagesConsignments?.length) {
      return;
    }

    const now = Date.now();

    // Ignore special keys except Enter
    if (e.key.length > 1 && e.key !== "Enter") return;

    // First key
    if (!startTime.current) {
      startTime.current = now;
    }

    // Detect slow typing between keys
    if (lastTime.current && now - lastTime.current > MAX_IDLE_TIME) {
      reject();
      return;
    }

    lastTime.current = now;

    if (e.key === "Enter") {
      e.preventDefault();
      processEnd();
      return;
    }

    buffer.current += e.key;

    // Fallback if no Enter
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      processEnd();
    }, 120);
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (!packagesConsignments?.length) {
      return;
    }

    const pasted = e.clipboardData.getData("text");

    if (pasted.length < MIN_LENGTH) {
      reject();
      return;
    }

    // Treat paste as scanner-equivalent
    // setError("");
    setSealNo(pasted);
    verifyBag(pasted);
    // eslint-disable-next-line no-console
    console.log("✅ Pasted (treated as scan)");

    reset();
  };

  const verifyBag = (seal: string) => {
    if (!seal) {
      return;
    }

    const bagScanned = packagesConsignments?.find(
      (bag: any) => bag.sealNo === seal && bag.discrepancyType,
    );

    if (bagScanned) {
      setSealNoError(true);
      return;
    }
    setSealNoError(false);

    const bagFound = packagesConsignments?.findIndex(
      (srb: any) => srb.sealNo === seal,
    );
    if (bagFound !== -1) {
      const updatedArray = packagesConsignments?.slice();
      updatedArray[bagFound] = {
        ...packagesConsignments[bagFound],
        discrepancyType: "None",
        isValidated: true,
      };
      setPackagesConsignments(updatedArray);
    } else {
      Swal.fire({
        icon: "warning",
        text: `You have scanned an incorrect package (${seal}). Do you want to continue?`,
      });
      setPackagesConsignments([
        ...packagesConsignments,
        {
          sealNo: seal,
          discrepancyType: "Extra",
        },
      ]);
    }

    setSealNo("");
  };

  const handleVerifyDiscrepancy = () => {
    recordReceivedDiscrepancy({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
      shift: "morning",
      consignments: packagesConsignments?.map((i: any) =>
        i?.discrepancyType ? i : { ...i, discrepancyType: "Missing" },
      ),
      coinsBoxes: coinsConsignments?.filter(
        (i: any) => i?.receivedCount > 0 || i.count > 0,
      ),
    });
  };

  const onConfirmReceiveOrdersBtnClicked = () => {
    receiveOrders(
      consignments?.map((item: any) => ({
        requestId: item?.requestId,
        jobNo: item?.jobNo,
        serviceType: item?.serviceType,
        jobType: item?.jobType,
        routeNo: item?.routeNo,
      })),
    );
  };

  function CoinsReceived(props: GridCellProps) {
    const { dataItem, field, dataIndex } = props;

    const inputRef2 = useRef<number>(0);
    const onChange = (e: NumericTextBoxChangeEvent) => {
      let value = e.target.value as unknown as number;
      if (!e.target.value) value = 0;
      inputRef2.current = value;
    };

    const onBlur = () => {
      if (field)
        updateKeyInDenominationEntry(dataIndex, field, inputRef2?.current);
    };

    const updateKeyInDenominationEntry = (
      rowIndex: number,
      columnID: string,
      value: number,
    ) => {
      setCoinsConsignments((old: any) =>
        old.map((row: any, index: number) => {
          if (index === rowIndex) {
            return {
              ...row,
              [columnID]: value,
              discrepancyType:
                row?.count === value
                  ? "None"
                  : row?.count > value
                    ? "Missing"
                    : "Extra",
              isValidated: row?.count === value,
            };
          }
          return row;
        }),
      );
    };

    return (
      <td>
        <NumericTextBox
          step={0}
          spinners={false}
          className="w-full h-10"
          value={field ? dataItem?.[field] : 0}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={0}
          min={0}
          required
        />
      </td>
    );
  }

  useEffect(() => {
    if (incomingOrdersSuccess) {
      setPackagesConsignments(incomingOrders?.containers);
      setCoinsConsignments(incomingOrders?.coinsBoxes);
      setConsignments(incomingOrders?.requests);
    }
    if (incomingOrdersError) {
      setPackagesConsignments([]);
      setCoinsConsignments([]);
      setConsignments([]);
    }
  }, [incomingOrdersSuccess, incomingOrdersError]);

  useEffect(() => {
    if (recordDiscrepancySuccess) {
      resetDiscrepancy();
      showToast("success", "Discrepancy Recorded Successfully!");
    }
  }, [recordDiscrepancySuccess]);

  useEffect(() => {
    if (downloadSuccess) {
      resetDownload();
      if (excelExporter.current) {
        const options = excelExporter.current.workbookOptions();
        const rows = options.sheets[0].rows;

        const cellOptions = { bold: true, borderBottom: true };
        rows.unshift({
          type: "data",
          cells: [
            {
              value: `Date: ${format(operationDate || currentDate, "dd-MMM-yyyy")}`,
              ...cellOptions,
            },
          ],
        });
        options.sheets[0].freezePane.rowSplit = 6;

        excelExporter.current.save(options);
      }
      showToast("success", "Download Recorded Successfully!");
    }
  }, [downloadSuccess]);

  useEffect(() => {
    if (receiveOrdersSuccess) {
      handleDownloadRecordDiscrepancy();
      resetReceipt();
      resetInComings();
    }
  }, [receiveOrdersSuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Inter Branch Management</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <Tabs value={operationType} onValueChange={setOperationType}>
            <TabsList className="flex mt-3 max-w-80">
              <TabsTrigger className="flex-1" value="dispatch">
                Dispatch
              </TabsTrigger>
              <TabsTrigger className="flex-1" value="receiving">
                Receiving
              </TabsTrigger>
            </TabsList>
            <TabsContent value="dispatch">
              <Dispatch />
            </TabsContent>
            <TabsContent value="receiving">
              <div className="flex mt-3 gap-2">
                <div className="max-w-[340px] w-full">
                  <DatePicker
                    selectedDate={operationDate}
                    onSelectDate={onOperationDateChanged}
                    placeholder="Select Date"
                  />
                </div>

                <div className="w-full max-w-[340px]">
                  <Combobox
                    value={ddlCashCenters}
                    data={cashCenters
                      ?.filter(
                        (cc: any) => cc.cashCenterId !== user?.CashCenterId,
                      )
                      ?.map((route) => ({
                        value: route.cashCenterId,
                        label: `${route.name} (${route.locationId})`,
                      }))}
                    placeholder="Select Source Cash Center"
                    setValue={setDdlCashCenters}
                  />
                </div>
                <div className="w-full max-w-[340px]">
                  <Combobox
                    value={ddlRoutes}
                    data={routes?.map((route) => ({
                      value: route.routeNo,
                      label: `${route.routeNo} (${route.description})`,
                    }))}
                    placeholder="Select Route"
                    setValue={setDdlRoutes}
                  />
                </div>
                <Button
                  variant="secondary"
                  className="max-w-[200px] w-full ml-auto"
                  onClick={onConfirmReceiveOrdersBtnClicked}
                  isLoading={receiveOrdersPending || downloadPending}
                  disabled={
                    !packagesConsignments?.length || recordDiscrepancyPending
                  }
                >
                  Confirm Receive
                </Button>
                <Button
                  variant="secondary"
                  className="max-w-[200px] w-full"
                  onClick={handleDownloadRecordDiscrepancy}
                  disabled={downloadPending}
                  isLoading={downloadPending}
                >
                  <FileDownIcon /> Download
                </Button>
                {reportData ? (
                  <RouteEndReportGenerator data={reportData} />
                ) : null}
              </div>
              <div className="border-b my-3 bg-accent" />

              <div className="flex gap-3">
                <div className="max-w-[686px] w-full">
                  <Input
                    placeholder="Scan bag"
                    ref={inputRef}
                    value={sealNo}
                    onKeyDown={handleKeyDown}
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onChange={() => {}} // fully controlled
                    onPaste={handlePaste}
                    className={cn(
                      "w-full",
                      sealNoError ? "border-red-500" : "",
                    )}
                  />
                  {sealNoError ? (
                    <i className="text-xs text-red-500">
                      Seal already scanned.
                    </i>
                  ) : null}
                </div>
                <div className="border rounded-sm p-2">
                  {
                    packagesConsignments?.filter((i: any) => i.discrepancyType)
                      ?.length
                  }
                  /{packagesConsignments?.length}
                </div>
                <Button
                  variant="secondary"
                  className="max-w-[200px] w-full"
                  onClick={handleVerifyDiscrepancy}
                  disabled={
                    !packagesConsignments?.length || recordDiscrepancyPending
                  }
                  isLoading={recordDiscrepancyPending}
                >
                  Verify Discrepancy
                </Button>
              </div>

              <div className="border-b my-3 bg-accent" />
              {loadingRequests ? (
                <div className="k-loading-mask">
                  <span className="k-loading-text">Loading</span>
                  <div className="k-loading-image" />
                  <div className="k-loading-color" />
                </div>
              ) : null}
              <div className="flex gap-3">
                <div className="w-[70%]">
                  <Grid data={consignments}>
                    <GridColumn field="orderId" title="Order Id" />
                    <GridColumn field="jobNo" title="Job No" />
                    <GridColumn field="customer" title="Customer" />
                    <GridColumn
                      field="sourceBarcode"
                      title="Source"
                      cell={({ dataItem }) => (
                        <td>{`${dataItem?.sourceBarcode}-${dataItem?.sourceLocation}`}</td>
                      )}
                    />
                    <GridColumn
                      field="onwardBarcode"
                      title="Onward"
                      cell={({ dataItem }) => (
                        <td>{`${dataItem?.onwardBarcode}-${dataItem?.onwardLocation}`}</td>
                      )}
                    />
                    <GridColumn field="status" title="Status" />
                    <GridColumn field="jobType" title="Job Type" />
                    <GridColumn field="serviceType" title="Service" />
                  </Grid>
                </div>
                <div className="w-[35%]">
                  <Tabs defaultValue="containers">
                    <TabsList className="flex">
                      <TabsTrigger className="flex-1" value="containers">
                        Containers
                      </TabsTrigger>
                      <TabsTrigger className="flex-1" value="coins">
                        Coins
                      </TabsTrigger>
                    </TabsList>
                    <TabsContent value="containers">
                      <Grid data={packagesConsignments}>
                        <GridColumn field="containerType" title="Container" />
                        <GridColumn field="sealNo" title="Seal No." />
                        <GridColumn
                          field="discrepancyType"
                          title="Discrepancy"
                          cell={({ field, dataItem }) => {
                            return (
                              <td>
                                {field ? (
                                  <span
                                    className={cn(
                                      dataItem[field] === "None"
                                        ? "text-green-500"
                                        : "text-red-500",
                                    )}
                                  >
                                    {dataItem[field] || "-"}
                                  </span>
                                ) : null}
                              </td>
                            );
                          }}
                        />
                      </Grid>
                    </TabsContent>
                    <TabsContent value="coins">
                      <Grid data={coinsConsignments} editField="receivedCount">
                        <GridColumn field="denomination" title="Denomination" />
                        <GridColumn field="containerType" title="Type" />
                        <GridColumn field="count" title="Count" />
                        <GridColumn
                          field="receivedCount"
                          title="Received"
                          cell={CoinsReceived}
                        />
                        <GridColumn
                          field="discrepancyType"
                          title="Discrepancy"
                          cell={({ field, dataItem }) => {
                            return (
                              <td>
                                {field ? (
                                  <span
                                    className={cn(
                                      dataItem[field] === "None"
                                        ? "text-green-500"
                                        : "text-red-500",
                                    )}
                                  >
                                    {dataItem[field] || "-"}
                                  </span>
                                ) : null}
                              </td>
                            );
                          }}
                        />
                      </Grid>
                    </TabsContent>
                  </Tabs>
                </div>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </Layout>
  );
}
